export default __webpack_public_path__ + "static/media/newSet2-1-min.8fb4c933.png";